<template>
  <div
    v-click-outside="close"
    :class="$style.compare_dropdown"
    :style="disabled ? {opacity: '.5', pointerEvents: 'none'} : null"
  >
    <div :class="$style.wrapper">
      <div
        ref="button"
        :class="[
          $style.button,
          showMenu ? $style.active : '',
        ]"
        @click="toggle"
      >
        <div :class="$style.label">
          {{ locales('reports_pages_model_of_calc') }}:
        </div>
        <div :class="$style.name">
          {{ label }}
        </div>
        <svg-sprite
          :class="$style.icon"
          :name="showMenu ? 'arrow-top' : 'arrow-down'"
          colo
          type="bold"
          :size="20"
        />
      </div>
    </div>

    <div :class="[$select.select, $select.reports_toolbar]">
      <context-menu
        v-if="showMenu"
        :position="positionMenu"
        style="min-width: 215px"
      >
        <template #body>
          <template v-for="(item, index) in menu">
            <div
              v-if="item.group"
              :key="index"
              :class="$select.group_title"
            >
              <div :class="$select.text">
                {{ item.group }}
              </div>
              <div :class="$select.line" />
            </div>

            <div
              v-if="item.type === 'item'"
              :key="index"
            >
              <tooltip
                v-if="item.tooltip"
                :class="$select.tooltip"
                :content="item.tooltip.content"
                :position="item.tooltip.position"
                :with-animation="false"
              >
                <template #body>
                  <div
                    :class="[
                      $select.menu_item,
                      item.isActive ? $select.active : '',
                      item.isDisabled ? $select.disabled : '',
                    ]"
                    @click="onSelect(item)"
                  >
                    <div :class="$select.text">
                      {{ item.text }}
                    </div>
                  </div>
                </template>
              </tooltip>
              <div v-else>
                <div
                  :class="[
                    $select.menu_item,
                    item.isActive ? $select.active : '',
                    item.isDisabled ? $select.disabled : '',
                  ]"
                  @click="onSelect(item)"
                >
                  <div :class="$select.text">
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="item.type === 'submenu'"
              :key="index"
            >
              <tooltip
                v-if="item.tooltip"
                :class="$select.tooltip"
                :content="item.tooltip.content"
                :position="item.tooltip.position"
                :with-animation="false"
              >
                <template #body>
                  <div
                    :class="[
                      $select.menu_item,
                      $select.item_level,
                      item.isActive ? $select.active : '',
                      item.isDisabled ? $select.disabled : '',
                    ]"
                    @mouseenter="enterSelect(item.name, $event.target)"
                    @mouseleave="leaveSelect"
                  >
                    <div :class="$select.text">
                      {{ item.text }}
                    </div>
                    <svg-sprite
                      :class="$select.icon"
                      name="drop-right"
                      type="bold"
                      :size="24"
                      :style="{
                        'margin-right': 0,
                        'margin-left': 'auto',
                        'color': '#b2b2b2',
                      }"
                    />

                    <context-menu
                      v-if="showSubmenuName === item.name && item.list.length"
                      class="gantt_scroll"
                      :position="positionSubmenu"
                      side="right"
                      :offset="{ top: -8 }"
                      :style="{
                        'max-height': '270px',
                        'min-width': '215px',
                        'border-top-left-radius': 0,
                        'border-bottom-left-radius': 0,
                      }"
                    >
                      <template #body>
                        <div
                          v-for="(subitem, index2) in item.list"
                          :key="index2"
                          :class="[
                            $select.menu_item,
                            subitem.id == item.selectedSubmenuId ? $select.active : '',
                          ]"
                          @click="onSelect(item, subitem)"
                        >
                          <div
                            :class="$select.text"
                            :style="{width: '190px'}"
                          >
                            {{ subitem.name }}
                          </div>
                        </div>
                      </template>
                    </context-menu>
                  </div>
                </template>
              </tooltip>

              <div v-else>
                <div
                  :class="[
                    $select.menu_item,
                    $select.item_level,
                    item.isActive ? $select.active : '',
                    item.isDisabled ? $select.disabled : '',
                  ]"
                  @mouseenter="enterSelect(item.name, $event.target)"
                  @mouseleave="leaveSelect"
                >
                  <div :class="$select.text">
                    {{ item.text }}
                  </div>
                  <svg-sprite
                    :class="$select.icon"
                    name="drop-right"
                    type="bold"
                    :size="24"
                    :style="{
                      'margin-right': 0,
                      'margin-left': 'auto',
                      'color': '#b2b2b2',
                    }"
                  />

                  <context-menu
                    v-if="showSubmenuName === item.name && item.list.length"
                    class="gantt_scroll"
                    :position="positionSubmenu"
                    side="right"
                    :offset="{ top: -8 }"
                    :style="{
                      'max-height': '270px',
                      'min-width': '215px',
                      'border-top-left-radius': 0,
                      'border-bottom-left-radius': 0,
                    }"
                  >
                    <template #body>
                      <div
                        v-for="(subitem, index2) in item.list"
                        :key="index2"
                        :class="[
                          $select.menu_item,
                          subitem.id == item.selectedSubmenuId ? $select.active : '',
                        ]"
                        @click="onSelect(item, subitem)"
                      >
                        <div
                          :class="$select.text"
                          :style="{width: '190px'}"
                        >
                          {{ subitem.name }}
                        </div>
                      </div>
                    </template>
                  </context-menu>
                </div>
              </div>
            </div>
          </template>
        </template>
      </context-menu>
    </div>
  </div>
</template>

<script>
import tooltip from '../../common/VueComponents/tooltips/tooltip.vue';

export default {
  components: { tooltip },
  props: {
    menu: { type: Array, default: () => [] },
    disabled: { type: Boolean, required: false, default: false },
  },
  emits: {
    onOpen: null,
    onSelect: Object,
  },
  data() {
    return {
      locales: __,
      showMenu: false,
      positionMenu: null,
      showSubmenuName: '',
      positionSubmenu: null,
      selectedType: null,
    };
  },
  computed: {
    label() {
      return this.menu.find(m => m.isActive).text;
    },
  },
  methods: {
    toggle() {
      this.showMenu = !this.showMenu;
      if (this.showMenu) {
        this.positionMenu = this.$refs.button.getBoundingClientRect();
        this.$emit('onOpen');
      }
    },
    close() {
      this.showMenu = false;
      this.showSubmenuName = '';
    },
    enterSelect(selectName, el) {
      this.showSubmenuName = selectName;
      this.positionSubmenu = el.getBoundingClientRect();
    },
    leaveSelect() {
      this.showSubmenuName = '';
    },
    onSelect(item, baseline) {
      const type = item.name;
      const baselineId = baseline ? baseline.id : null;

      this.close();
      this.$emit('onSelect', { type, baselineId });
    },
  },
};
</script>

<style module lang='less'>
@import '../../../less/_fonts.less';

@iconColor: #333333;
@labelColor: #191919;
@activeColor: #1565C0;
@hoverBg: #F2F2F2;
@activeBg: #D0E0F2;
@activeHoverBg: #A1C1E6;

.compare_dropdown {
  margin-left: -8px;

  .wrapper {
    display: flex;
    align-items: center;

    .button {
    display: inline-flex;
    vertical-align: top;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    cursor: pointer;
    border-radius: 4px;
    background: transparent;
    color: @iconColor;
    .FontLatoRegular;
    user-select: none;
    font-size: 12px;
    line-height: 24px;
    height: 24px;
    padding: 0 4px 0 8px;

    .label {
      font-size: 12px;
      .FontLatoRegular;
      color: @labelColor;
    }

    &:hover {
      background: @hoverBg;
    }
    &:active {
      color: @activeColor;
      background: @activeBg;

      .label,
      .name {
        color: inherit;
      }
    }

    &.active {
      color: @activeColor;
      background: @activeBg;

      &:hover {
        background: @activeHoverBg;
      }
      &:active {
        background: @activeBg;
      }

      .label,
      .name {
        color: inherit;
      }
    }

    .name {
      .FontLatoBold;
      color: @activeColor;
      padding: 0 4px;
      white-space: nowrap;
    }

    .icon {
      pointer-events: none;
    }
  }
  }
}
</style>
<style module='$select' src="../../header/less/select.less"></style>
